import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, inject, Input, Output, signal } from '@angular/core';
import {
  BannerPictureType,
  FeedItem,
  isFeedItemOfMediaType,
  isFeedItemOfSystemVideoV1Type, isFeedItemOfSystemVideoV2Type, isFeedItemOfUserVideoV2Type,
  Media,
  MediaActionsMode,
} from '@core/models';
import { OverlayService, ShareLinkService } from '@core/services';
import { AvatarComponent, IconComponent } from '@shared/components';
import { RippleDirective, ThrottleClickDirective } from '@shared/directives';
import { ShortNumberPipe } from '@shared/pipes';
import { AnalyticsDirective } from '@shared/directives/analytics.directive';
import { AnalyticsEventsEnum } from '@core/models/analytics.model';
import { SystemVideoV1, UserVideoV2 } from '@api/backend';
import { BreakpointFacade } from '@core/facades';

@Component({
  standalone: true,
  selector: 'cheelee-media-actions',
  imports: [
    CommonModule,
    AvatarComponent,
    IconComponent,
    ShortNumberPipe,
    RippleDirective,
    ThrottleClickDirective,
    AnalyticsDirective,
  ],
  templateUrl: './media-actions.component.html',
  styleUrl: './media-actions.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MediaActionsComponent {
  private readonly overlayService = inject(OverlayService);

  private readonly shareLinkService = inject(ShareLinkService);

  protected readonly analyticsEvents = AnalyticsEventsEnum;

  protected readonly isMobile = inject(BreakpointFacade).isMobile;


  @Output()
  public openComments = new EventEmitter<void>();

  @Output()
  public closeComments = new EventEmitter<void>();

  @Input()
  public mode: MediaActionsMode = MediaActionsMode.RECOMMENDATIONS;

  @Output()
  public like = new EventEmitter<void>();

  // @ViewChild('avatar', { read: AvatarComponent })
  // private readonly avatar!: AvatarComponent;

  @Input({ required: true })
  public set item(value: FeedItem) {
    if (isFeedItemOfMediaType(value)) {
      this.media.set(value.object);
    } else if (isFeedItemOfSystemVideoV1Type(value) || isFeedItemOfSystemVideoV2Type(value)) {
      this.ad.set(value.object);
    } else if (isFeedItemOfUserVideoV2Type(value)) {
      this.userVideo.set(value.object);
    }
  }

  public media = signal<Media | undefined>(undefined);

  public userVideo = signal<UserVideoV2 | undefined>(undefined);

  public ad = signal<SystemVideoV1 | undefined>(undefined);

  public withLikeAnimation = signal(false);

  protected openGetAppDialog(action:AnalyticsEventsEnum, picture?: BannerPictureType): void {
    return this.overlayService.openGetAppDialog(action, picture);
  }

  protected openShareCurtain(mediaId?: string, mediaName?: string): void {
    if (mediaId) {
      return this.shareLinkService.share(mediaId, mediaName ?? 'Watch Cheelee - get cash | Cheelee', 'media');
    }
  }
}
